import HomeRegular from "Static/img/PUC _Icon_Set/Home.svg";
import HomeFilled from "Static/img/PUC_Icon_Set_filled/Home.svg";
import AllRequestRegular from "Static/img/PUC _Icon_Set/All Request.svg";
import AllRequestFilled from "Static/img/PUC_Icon_Set_filled/All Request.svg";
import DocVerificationRegular from "Static/img/PUC _Icon_Set/Doc Verification.svg";
import DocVerificationFilled from "Static/img/PUC_Icon_Set_filled/Doc Verification.svg";
import FurnitureRegular from "Static/img/PUC _Icon_Set/Furniture Setup.svg";
import FurnitureFilled from "Static/img/PUC_Icon_Set_filled/Furniture Setup.svg";
import DepositRegular from "Static/img/PUC _Icon_Set/Deposit Check.svg";
import DepositFilled from "Static/img/PUC_Icon_Set_filled/Deposit Check.svg";
import LocationCheckRegular from "Static/img/PUC _Icon_Set/Location Check.svg";
import LocationCheckFilled from "Static/img/PUC_Icon_Set_filled/Location Check.svg";
import ManageRolesRegular from "Static/img/PUC _Icon_Set/Manage Roles.svg";
import ManageRolesFilled from "Static/img/PUC_Icon_Set_filled/Manage Roles.svg";
import ManageUsersRegular from "Static/img/PUC _Icon_Set/Manage Users.svg";
import ManageUsersFilled from "Static/img/PUC_Icon_Set_filled/Manage Users.svg";
import MaterialDispatchRegular from "Static/img/PUC _Icon_Set/Material Dispatch.svg";
import MaterialDispatchFilled from "Static/img/PUC_Icon_Set_filled/Material Dispatch.svg";
import MaterialHandoverRegular from "Static/img/PUC _Icon_Set/Material Handover.svg";
import MaterialHandoverFilled from "Static/img/PUC_Icon_Set_filled/Material Handover.svg";
import ManageBankRegular from "Static/img/PUC _Icon_Set/Manage Bank.svg";
import MangeBankFilled from "Static/img/PUC_Icon_Set_filled/Manage Bank.svg";
import FurnitureFixtures from "Static/img/PUC _Icon_Set/Furniture Fixtures.svg";
import StoreRegular from "Static/img/PUC _Icon_Set/Store.svg";
import StoreFilled from "Static/img/PUC_Icon_Set_filled/Store.svg";
import PaymentRegular from "Static/img/PUC _Icon_Set/Payment Outline.svg";
import PaymentFilled from "Static/img/PUC_Icon_Set_filled/Payment Fill.svg";
import TemplateFilled from "Static/img/PUC_Icon_Set_filled/Template Fill.svg";
import TemplateRegular from "Static/img/PUC _Icon_Set/Template Outline.svg";
import BankBranchFilled from "Static/img/PUC_Icon_Set_filled/Branches Fill.svg";
import BankBranchRegular from "Static/img/PUC _Icon_Set/Branches Outline.svg";
import ItemsRegular from "Static/img/PUC _Icon_Set/Item Outline.svg";
import ItemsFilled from "Static/img/PUC_Icon_Set_filled/Item Fill.svg";
import LocationExceptionRegular from "Static/img/PUC _Icon_Set/location_exception.svg";
import LocationExceptionFilled from "Static/img/PUC_Icon_Set_filled/location_exception_filled.svg";
import RCMBankRegular from "Static/img/PUC _Icon_Set/RCMBank.svg"
import RCMBankFilled from "Static/img/PUC_Icon_Set_filled/RCMBankFilled.svg"
import DisplayWallRegular from "Static/img/PUC _Icon_Set/Display Wall.svg"
import DisplayWallFilled from "Static/img/PUC_Icon_Set_filled/Display Wall.svg"

export const icons = {
  Home: {
    regular: HomeRegular,
    filled: HomeFilled
  },
  AllRequest: {
    regular: AllRequestRegular,
    filled: AllRequestFilled
  },
  DocVerification: {
    regular: DocVerificationRegular,
    filled: DocVerificationFilled
  },
  Furniture: {
    regular: FurnitureRegular,
    filled: FurnitureFilled
  },
  Deposit: {
    regular: DepositRegular,
    filled: DepositFilled
  },
  Location_check: {
    regular: LocationCheckRegular,
    filled: LocationCheckFilled
  },
  Manage_Roles: {
    regular: ManageRolesRegular,
    filled: ManageRolesFilled
  },
  Manage_Users: {
    regular: ManageUsersRegular,
    filled: ManageUsersFilled
  },
  Material_dispatch: {
    regular: MaterialDispatchRegular,
    filled: MaterialDispatchFilled
  },
  Material_handover: {
    regular: MaterialHandoverRegular,
    filled: MaterialHandoverFilled
  },
  Manage_bank: {
    regular: ManageBankRegular,
    filled: MangeBankFilled
  },
  Manage_branch: {
    regular: BankBranchRegular,
    filled: BankBranchFilled
  },
  Furniture_Fixtures: {
    regular: FurnitureFixtures,
    filled: FurnitureFixtures
  },
  Store: {
    regular: StoreRegular,
    filled: StoreFilled
  },
  Payment: {
    regular: PaymentRegular,
    filled: PaymentFilled
  },
  Items: {
    regular: ItemsRegular,
    filled: ItemsFilled
  },
  Template: {
    regular: TemplateRegular,
    filled: TemplateFilled
  },
  Location_Exception: {
    regular: LocationExceptionRegular,
    filled: LocationExceptionFilled
  },
  RCM_Bank_Management:{
    regular: RCMBankRegular,
    filled: RCMBankFilled
  },
  Display_Wall:{
    regular: DisplayWallRegular,
    filled: DisplayWallFilled
  }
};
